// extracted by mini-css-extract-plugin
export default {"promo":"HardwareFirstCartPromo_promo__N8Qno"};